<template>
  <el-container :style="{ height: clientHeight + 'px'}">

    <!-- left start -->
    <div id="left-container">

      <!-- logo start -->
      <el-container>
        <router-link to="/">
          <div id="logo"
               :class="[collapse ? 'collapse' : 'not-collapse']">
            <img v-show="!collapse"
                 src="~@assets/logo/logo-full-yellow-90.png">
            <img v-show="collapse"
                 src="~@assets/logo/logo-collapse.png">
          </div>
        </router-link>
      </el-container>
      <!-- logo end -->

      <!-- menu start -->
      <el-aside
        id="menu"
        :class="[collapse ? 'collapse' : 'not-collapse']"
        :style="{ height: (clientHeight - 50) + 'px' }">
        <layout-menu/>
      </el-aside>
      <!-- menu end -->

    </div>
    <!-- left end -->

    <!-- right -->
    <div id="right-container">

      <!-- header start -->
      <el-container id="header">
        <layout-header/>
      </el-container>
      <!-- header end -->


      <!-- main start -->
      <div
        id="main-container"
        v-loading="!!~~loading">
        <el-main
          id="main"
          :style="{ height: $root.mainHeight + 'px'}">
          <router-view></router-view>
        </el-main>
      </div>
      <!-- main end -->

      <!-- footer start -->
      <el-footer
        id="footer"
        height="20">
        <span>© 2023 擞因科技, Inc. · Privacy · Terms · </span>
        <span>Versions {{VUE_APP_VERSION}}</span>
      </el-footer>
      <!-- footer end -->

    </div>
    <!-- right end -->
  </el-container>
</template>

<script>
import LayoutHeader from './LayoutHeader'
import LayoutMenu from './LayoutMenu'

export default {
  components: {LayoutMenu, LayoutHeader},
  data () {
    return {
      VUE_APP_VERSION: window._env_.VUE_APP_VERSION,
    }
  },
  computed: Vuex.mapState({
    loading: state => state.loadingMain,
    collapse: state => state.collapseMenu,
    clientHeight: state => state.clientHeight,
    clientWidth: state => state.clientWidth,
    user: state => state.login.user,
  }),
  watch: {},
  beforeCreate () {},
  created () {
    let environment
    if (location.href.includes('.ci.slicejobs.com')) {
      environment = 'pre'
    } else if (location.href.includes('.dev.slicejobs.com')) {
      environment = 'daily'
    } else if (location.href.includes('.slicejobs.com')) {
      environment = 'prod'
    } else {
      environment = 'local'
    }
    window.__bl && window.__bl.setConfig({
      uid: this.user.id,
      setUsername: () => {
        return this.user.name
      },
      environment,
    })
  },
  methods: {},
}
</script>

<style lang="scss">
$leftWidth: 200px;

#left-container {
  .collapse {
    width: 64px !important;
  }

  .not-collapse {
    width: $leftWidth !important;
  }
}

#right-container {
  width: 100%;
  overflow: hidden;
}

#logo {
  width: $leftWidth;
  height: 48px;
  cursor: pointer;
  background-color: #424f63;
  color: white;
  line-height: 48px;
  text-align: center;

  img {
    width: 100%;
    height: 48px;
    // vertical-align: middle;
    display: inline-block;
  }
}

#menu {
  width: $leftWidth;
  background-color: rgb(66, 79, 99);
  overflow-x: hidden;
}

#header {
  width: 100%;
  height: 50px;
  border-bottom: 1px solid #eff0f4;
  background-color: #fff;

  .el-header {
    padding: 0 0 0 0;
    color: #333;
    line-height: 50px;

    .logo {
      cursor: pointer;
      background-color: #424f63;
      width: 100%;
      height: 50px;
      color: white;
      line-height: 50px;
      text-align: center;

      img {
        height: 26px;
        vertical-align: middle;
        display: inline-block;
      }
    }
  }
}

#main-container {
  width: 100%;
  background-color: #eff0f4;
  position: relative;
}

#main {
  overflow-x: hidden;
  overflow-y: scroll;
  padding-right: 10px;
}

#footer {
  line-height: 20px;
  background-color: #fff;
  color: #999;
  border-top: 1px solid #eff0f4;
  text-align: center;
  font-size: 10px;
}
</style>

<style lang="scss"
       scoped>
</style>



// WEBPACK FOOTER //
// src/layout/Index.vue